import { EventEmitter } from '@angular/core';
var ItemComponent = (function () {
    function ItemComponent() {
        this.outPutDownload = new EventEmitter();
        this.outPutData = new EventEmitter();
        this.outPutFileLoad = new EventEmitter();
        this.outPutDelFile = new EventEmitter();
        this.outPutCanSave = new EventEmitter();
        this.outPutPreview = new EventEmitter();
        this.questionNo = 1;
        this.assetsRoute = '../../../assets';
        this.disabledAdd = false;
        this.disabledUpload = false;
        this.isShowAnalysis = false; //是否显示实时答案
        this.isShowExpand = 'down';
        this.workType = ["主观题", "", "", "", "主观题", "", "", ""];
    }
    ItemComponent.prototype.ngOnInit = function () {
        if (this.exerciseType == 5 && this.pdfList && this.pdfList.length > 0) {
            this.downloadFile();
        }
    };
    ItemComponent.prototype.ngAfterViewInit = function () {
    };
    //下载pdf和图片收拢时的数据截取
    ItemComponent.prototype.downloadFile = function () {
        var _this = this;
        this.homeworkImgList = [];
        this.homeworkPdfList = [];
        //全是pdf
        this.pdfList.every(function (item) {
            var itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
            if (itemType === 'pdf') {
                _this.homeworkPdfList = _this.pdfList;
                //判断长度是否大于3个
                if (_this.homeworkPdfList.length > 3) {
                    _this.homeworkPdfList = _this.homeworkPdfList.filter(function (item, index) { return index < 3; });
                    _this.downloadType = "pdf";
                }
            }
            else if (itemType !== 'pdf') {
                _this.homeworkImgList = _this.pdfList;
                //判断长度是否大于3个
                if (_this.homeworkImgList.length > 3) {
                    _this.homeworkImgList = _this.homeworkImgList.filter(function (item, index) { return index < 3; });
                    _this.downloadType = "img";
                }
            }
            else {
                _this.pdfList.forEach(function (item) {
                    var itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
                    if (itemType == "pdf") {
                        _this.homeworkPdfList.push(item);
                    }
                    else {
                        _this.homeworkImgList.push(item);
                    }
                });
                if (_this.homeworkPdfList.length > 2 || _this.homeworkImgList.length > 3) {
                    _this.downloadType = "all";
                    _this.homeworkPdfList = _this.homeworkPdfList.filter(function (item, index) { return index < 2; });
                    _this.homeworkImgList = _this.homeworkImgList.filter(function (item, index) { return index < 3; });
                }
            }
        });
    };
    //下载pdf和图片展开时的数据截取
    ItemComponent.prototype.fileExpand = function () {
        if (this.isShowExpand == 'down') {
            if (this.downloadType == 'pdf') {
                this.homeworkPdfList = this.pdfList;
            }
            else if (this.downloadType == 'img') {
                this.homeworkImgList = this.pdfList;
            }
            else {
                var pdfArr_1 = [];
                var imgArr_1 = [];
                this.pdfList.forEach(function (item) {
                    var itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
                    if (itemType == "pdf") {
                        pdfArr_1.push(item);
                    }
                    else {
                        imgArr_1.push(item);
                    }
                });
                this.homeworkPdfList = pdfArr_1;
                this.homeworkImgList = imgArr_1;
            }
        }
        else {
            this.downloadFile();
        }
        this.isShowExpand = this.isShowExpand === 'down' ? 'up' : 'down';
    };
    /**
     * 预览
     * @param url:  String     预览文件的地址
     * @param type: Number     预览文件的类型
     */
    ItemComponent.prototype.showPreview = function (url, type) {
        this.outPutPreview.emit({ 'fileUrl': url, 'fileType': type });
    };
    /**
     * 下载PDF文件
     * @param url: String PDF's URL
     */
    ItemComponent.prototype.downloadPDF = function (url) {
        this.outPutDownload.emit(url);
    };
    /**
     * 收拢展开
     * @param id: Number 收拢展开的标识
     */
    ItemComponent.prototype.collapseAndExpend = function (id) {
        var arrow = $('#arrow-' + id), body = $('.answer-' + id);
        if (arrow.hasClass('rotateX180')) {
            console.log('收拢');
            arrow.removeClass('rotateX180');
            body.addClass('height0');
        }
        else {
            arrow.addClass('rotateX180');
            body.removeClass('height0');
            $(".question-show-wrap-" + id).hasClass("active") ? $(".question-show-wrap-" + id).removeClass('active') : "";
        }
    };
    /**
     * 触发文件上传
     */
    ItemComponent.prototype.startUpload = function () {
        console.log(this.uploadDisabled);
        if (this.uploadDisabled) {
            return false;
        }
        else {
            $('#upload_input').click();
        }
    };
    /**
     * 文件上传
     * @param e: input[type='file'] 上传input对象
     * @param id: number  问题Id
     */
    ItemComponent.prototype.uploadFile = function (e) {
        this.isShowMsg = false;
        var formData = new FormData();
        formData.append('file', $(e.target)[0].files[0]);
        this.outPutFileLoad.emit({ 'files': formData, 'el': e.target });
        $(e.target).attr('type', 'text');
    };
    /**
     * 上传文件删除
     * @param index: Number  上传文件的下标
     */
    ItemComponent.prototype.deleteFile = function (index) {
        window.event.cancelBubble = true;
        this.outPutDelFile.emit({ 'index': index });
    };
    /**
     * 获取文本组件传递过来的数据
     * @param event: Object 文本框数据对象
     */
    ItemComponent.prototype.getTextareaComponentValue = function (event) {
        this.outPutCanSave.emit(true);
        if (event['type'] === 3) {
            this.stepGroup[event['index']][0] = this.stepGroup[event['index']][0] ? this.stepGroup[event['index']][0] : '';
            this.stepGroup[event['index']][1] = event['content'] ? event['content'] : '';
        }
        this.outPutData.emit({
            'constituteId': this.lpmapcId,
            'questionId': event['questionId'],
            'selector': event['content'],
            'type': event['type'],
            'wordOverrun': event['wordOverrun']
        });
    };
    return ItemComponent;
}());
export { ItemComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-item/item.component.ts.pre-build-optimizer.js